









import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'AgroGenericModal',
})
export default class AgroGenericModal extends Vue {
  @Prop({ type: Boolean, default: false }) private isLarger!: boolean;
}
